export const getYouTubeId = (url) => {
  if (!url) return null;
  
  // If it's already an 11-char ID
  if (url.length === 11 && !url.includes('/') && !url.includes('.')) {
    return url;
  }

  // Enhanced regex to support shorts, standard URLs, and various formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  
  if (match && match[2].length === 11) {
    return match[2];
  }

  // Fallback for cases like youtube.com/v/ID or other variations
  try {
    const urlObj = new URL(url);
    if (urlObj.hostname.includes('youtube.com') || urlObj.hostname === 'youtu.be') {
        const searchParams = new URLSearchParams(urlObj.search);
        if (searchParams.has('v')) return searchParams.get('v');
        
        const pathParts = urlObj.pathname.split('/');
        const lastPart = pathParts[pathParts.length - 1];
        if (lastPart.length === 11) return lastPart;
    }
  } catch (e) {
    // If not a valid URL, try one last check for an 11 char string at the end
    const last11 = url.slice(-11);
    if (last11.length === 11 && !last11.includes('/') && !last11.includes(' ')) {
        return last11;
    }
  }

  return null;
};

export const getYouTubeThumbnail = (url, quality = 'maxresdefault') => {
  const id = getYouTubeId(url);
  if (!id) return null;
  // i.ytimg.com is YouTube's image CDN (no auth cookies, unlike img.youtube.com).
  // If maxresdefault is not available, YouTube redirects or serves a default.
  // But hqdefault is almost always available.
  return `https://i.ytimg.com/vi/${id}/${quality}.jpg`;
};

export const isYouTubeUrl = (url) => {
  return !!getYouTubeId(url);
};
